import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=7ceb2b89&scoped=true"
import script from "./PopupDialog.vue?vue&type=script&lang=ts"
export * from "./PopupDialog.vue?vue&type=script&lang=ts"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=7ceb2b89&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceb2b89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ceb2b89')) {
      api.createRecord('7ceb2b89', component.options)
    } else {
      api.reload('7ceb2b89', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=7ceb2b89&scoped=true", function () {
      api.rerender('7ceb2b89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/PopupDialog.vue"
export default component.exports